import { useQuery } from '@tanstack/react-query';
import { client } from '@/lib/api';

/**
 * What a planner still owes first-time setup, as the server derives it —
 * see `backend/src/routes/setup.ts` for why nothing here is stored.
 *
 * Shared by three readers that must not disagree: the checklist on /welcome,
 * the follow-up card on the dashboard, and the gate that decides a brand new
 * account belongs on /welcome at all. One query key means one answer and one
 * request per five minutes, not three.
 */
export function useSetupStatus() {
  return useQuery({
    queryKey: ['setup-status'],
    queryFn: async () => {
      const res = await client.api.setup.status.$get();
      if (!res.ok) throw new Error('Failed to load setup status');
      return res.json();
    },
  });
}
